import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHandler, HttpParams, HttpResponse } from '@angular/common/http';
import { map, first, filter, tap, delay, timeout, catchError, mergeMap } from 'rxjs/operators';
import { Observable, of, throwError, observable } from 'rxjs';
import { deviceService } from '../services-hardware/deviceService';
import { AlertService } from './alert.service';
import { HttpHeaders } from '@angular/common/http';
// import {_throw} from 'rxjs/observable/throw';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PostJsonObjectService {
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private deviceService: deviceService,
    private router: Router,
  ) {}

  public dataOutput: any;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  sendJson<T>(url: string, object?: any, _httpOption?: any, selfCatchError: boolean = true): Observable<any> {
    if (_httpOption != null) {
      this.httpOptions = _httpOption;
    }

    if (object == null) {
      object = '';
    }

    if (url != null) {
      return this.http.post(url, object, this.httpOptions).pipe(
        map((data) => {
          return data;
        }),
        catchError((e: any) => {
          return new Observable((observer) => {
            console.log('e : ', e);
            if (selfCatchError) {
              if (e?.error?.title != null)
                this.alertService.error({
                  subType: '',
                  message: e.error?.title + ' (' + e.error?.detail + ') type error : ' + e.error?.status,
                });
              else
                this.alertService.error({
                  subType: '',
                  message: 'Erreur de communication avec le serveur',
                });
            }
            observer.next(e);
            observer.complete();
          });
        }),
      );
    } else
      return new Observable((observer) => {
        observer.next(null);
        observer.complete();
      });
  }
}
